import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal } from 'components';
import { TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { ModeratorService } from 'services';
import CreateModerator from './create-moderator';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	position: ''
}

class Moderators extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Cargo',
			'Correo',
			'Modulos autorizados',
			'Acciones'
		],
		visible: false,
		item: null,
		modules: [],
		visible_confirm: false, 
		visible_delete: false,
		visible_bulk_confirm: false, 
		visible_bulk_delete: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Moderadores',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.loadModules();
		this.load();
	}

	loadModules = async () => {
		const res: any = await ModeratorService.admin.getModules({
			withoutLoading: true
		});
		this.setState({
			modules: res.modules
		});
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ModeratorService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.moderators.rows,
			last_page: res.moderators.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	confirmDelete = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_confirm: true,
			item
		});
	}

	delete = async () => {
		const item: any = this.state.item;
		await ModeratorService.admin.delete({
			user_id: item.id
		});
		await this.setState({
			visible_delete: true,
			visible_confirm: false,
			item: null
		});
		this.load(true);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	bulkDelete = async () => {
		await ModeratorService.admin.bulkDelete({
			users_id: this.state.data.filter((i: any) => i.active).map((i: any) => i.id),
		});
		await this.setState({
			visible_bulk_delete: true,
			visible_bulk_confirm: false
		});
		this.load(true);
	}

	confirmBulkDelete = () => {
		this.setState({
			visible_bulk_confirm: true
		});
	}

	setActive = (index: number) => {
		let data: any = [...this.state.data];
		data[index].active = !data[index].active;
		this.setState({
			data
		});
	}

	setAllActive = () => {
		let data: any = [...this.state.data];
		if (data.filter((i: any) => i.active).length == data.length) {
			data.map((i: any) => {
				i.active = false;
				return i;
			});
		}
		else {
			data.map((i: any) => {
				if (!i.active) {
					i.active = true;
				}
				return i;
			});
		}
		this.setState({
			data
		});
	}

	onCloseConfirm = () => {
		this.setState({
			visible_confirm: false
		});
	}

	onCloseDelete = () => {
		this.setState({
			visible_delete: false
		});
	}

	onCloseBulkDelete = () => {
		this.setState({
			visible_bulk_delete: false
		});
	}

	onCloseBulkConfirm = () => {
		this.setState({
			visible_bulk_confirm: false
		});
	}

	render() {
		const { visible, visible_confirm, visible_delete, visible_bulk_confirm, visible_bulk_delete } = this.state;

		return (
			<div id="moderators">
				<BackComponent />

				<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar al moderador?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.delete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm: false,
										item: null
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha eliminado con éxito</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_bulk_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar los moderadores seleccionados?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.bulkDelete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_bulk_confirm: false
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_bulk_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se han eliminado con éxito</h3>
					</div>
		      	</Modal>

				<div className={ `container-modal-right ${ visible ? 'active' : '' }` }>
					{
						visible && (
							<CreateModerator
								modules={ this.state.modules }
								item={ this.state.item }
								title={ `${ this.state.item ? 'Editar' : 'Nuevo' } Moderador` }
								onClose={ () => this.onClose() }
							/>
						)
					}
				</div>

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-5">
								<Input
									value={ this.state.form.position }
									name="position"
									placeholder="Cargo"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						{
							checkPermission(Constants.MODULES.MODERATORS,'delete') && this.state.data.filter((i: any) => i.active).length > 0 && (
								<button className="btn btn-delete" onClick={ () => this.confirmBulkDelete() }>
									<img src={ TrashWhiteIcon } />
									Eliminar
								</button>
							)
						}
						{
							checkPermission(Constants.MODULES.MODERATORS,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header } childrenHeader={
					<th>
						{
							checkPermission(Constants.MODULES.MODERATORS,'delete') && (
								<CheckboxTable 
									active={ this.state.data.filter((i: any) => i.active).length == this.state.data.length } 
									onClick={ () => this.setAllActive() } />
							)
						}
					</th>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									{
										checkPermission(Constants.MODULES.MODERATORS,'delete') && (
											<CheckboxTable 
												active={ i.active } 
												onClick={ () => this.setActive(index) } />
										)
									}
								</td>
								<td>{ i.full_name }</td>
								<td>{ i.position }</td>
								<td>{ i.email }</td>
								<td className="bold">{ i.module_permissions.filter((i: any) => {
									return i.read || i.write || i.delete;
								}).length } Autorizados</td>
								<td>
									{
										checkPermission(Constants.MODULES.MODERATORS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.MODERATORS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.confirmDelete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Moderators);